<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="frontmatter_dedication _idGenParaOverride-1" xml:lang="en-GB">For Mirren and Gowan. Be your own heroines.</p>
<p class="frontmatter_copyright">Copyright © 2016 by Darby Creek</p>
<p class="frontmatter_copyright">Text copyright © 2013 Lari Don</p>
<p class="frontmatter_copyright">Illustrations copyright © 2013 Francesca Greenwood</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_copyright">This translation of <span class="frontmatter_CMS-Ital">Girls and Goddesses</span> is published by Darby Creek by arrangement with Bloomsbury Publishing Plc.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_copyright">All rights reserved. International copyright secured. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise—without the prior written permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotations in an acknowledged review.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_publisher-info">Darby Creek</p>
<p class="frontmatter_publisher-info">A division of Lerner Publishing Group, Inc.</p>
<p class="frontmatter_publisher-info">241 First Avenue North</p>
<p class="frontmatter_publisher-info">Minneapolis, MN 55401 USA</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_publisher-info">For reading levels and more information, look up this title at <a href="http://www.lernerbooks.com" target="_blank">www.lernerbooks.com.</a></p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_acknowledgments-and-credits">Main body text set in Sabon LT Std 13/19. Typeface provided by Adobe Systems.</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_CIP"><span class="frontmatter_emphasis _idGenCharOverride-1">Library of Congress Cataloging-in-Publication Data</span></p>
<p class="frontmatter_CIP">Names: Don, Lari, author. | Greenwood, Francesca, illustrator.</p>
<p class="frontmatter_CIP">Title: Girls and goddesses : stories of heroines from around the world / by Lari Don ; illustrations by Francesca Greenwood.</p>
<p class="frontmatter_CIP">Description: Minneapolis : Darby Creek, [2016] | Series: World of stories | Audience: Age: 7–12. | Audience: Grade 4 to 6.</p>
<p class="frontmatter_CIP">Identifiers: LCCN 2015046658 | ISBN <span class="frontmatter_ISBN">9781512413175</span> (lb : alk. paper) | ISBN <span class="frontmatter_ISBN">9781512413373</span> (pb : alk. paper) | ISBN <span class="frontmatter_ISBN">9781512413380</span> (eb pdf)</p>
<p class="frontmatter_CIP">Subjects: LCSH: Women heroes—Folklore—Juvenile literature.</p>
<p class="frontmatter_CIP">Classification: LCC GR515 .D66 2016 | DDC 398.2—dc23</p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_CIP">LC record available at <a href="http://lccn.loc.gov/2015046658" target="_blank">http://lccn.loc.gov/2015046658</a></p>
<p class="frontmatter_copyright"> </p>
<p class="frontmatter_manufacturing-info">Manufactured in the United States of America</p>
<p class="frontmatter_manufacturing-info">1 – SB – 7/15/16</p>
<p class="frontmatter_CIP">9781512419146 ePub</p>
<p class="frontmatter_CIP">9781512419153 ePub</p>
<p class="frontmatter_CIP">9781512419160 mobi</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// x13175_T.vue?3df50b65